// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileFilledSvg from "@ant-design/icons-svg/es/asn/SmileFilled";
import AntdIcon from '../components/AntdIcon';

var SmileFilled = function SmileFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmileFilledSvg
  }));
};

SmileFilled.displayName = 'SmileFilled';
export default React.forwardRef(SmileFilled);